import instance from '@/service/instance';
import { AxiosPromise} from 'axios'
import {HomeworkUpdateParams} from '@/helpers/types'

const resource: string = '/homework';

export default {
  list(token: string): AxiosPromise<any> {
    return instance.get(`${resource}/`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
  create({token, payload}: HomeworkUpdateParams): AxiosPromise<any> {
    return instance.post(`${resource}/`, payload,{
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
  edit({id, token, payload}: HomeworkUpdateParams): AxiosPromise<any> {
    return instance.patch(`${resource}/${id}`, payload,{
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  }
};
